module.exports = __webpack_public_path__ + "static/retmes-ai-pdf-doc-2-dc01a395881521570dbb2ac1107079a7.png";